import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import popup from './modules/popup';
import header from './modules/header';
import zIndex from './modules/zIndex';
import admin from './modules/admin';

import brands from '../components/Campaign/Targeting/Brands/store/brandsStore';
import langs from '../components/Campaign/Targeting/Langs/store/langsStore';
import apk from '../components/Common/UploadApk//store/uploadApk';
import doughnut from '../components/Common/StickyDoughnut/store/stickyDoughnut';
import scheduler from '../components/Campaign/Scheduler/store/scheduler';
import appsBudgets from '../components/Campaign/AppsBudgets/store/appsBudgets';
import graph from '../components/Common/Graph/store/graph';

let modules = {
    popup,
    header,
    zIndex,
    admin,
    brands,
    langs,
    apk,
    doughnut,
    scheduler,
    appsBudgets,
    graph,
};

export const store = new Vuex.Store({
    modules: modules,
});



// WEBPACK FOOTER //
// ./src/store/store.js